var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Carousel'),_c('AboutBrief'),_c('ProjectList',{attrs:{"projects":_vm.projects,"showMore":true}}),_c('PartnerWall',{attrs:{"partners":_vm.partners}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }